import request from '@/utils/request'

export function getNoticeList(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/getNoticeList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getContents(url) {
  return request({
    url: `/ftpDownload${url}`,
    method: 'GET',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' }
  })
}

export function admZ000Save(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/admZ000Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function admZ000Delete(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/admZ000Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsZ005List(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/epmsZ005List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsZ005Save(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/epmsZ005Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}


export function noticeBuilderList(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/noticeBuilderList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function noticeBuilderSave(param) {
  let data = param
  return request({
    url: `/zdmin/admZ000/noticeBuilderSave`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}